import { useEffect, useState } from "react";
import { Form, ListGroup } from "react-bootstrap";
import { MapArea } from "common/types/MapArea";
import { NameID } from "common/types/NameID";

type Props = {
  allArea: MapArea[];
  selecteds: NameID[];
  selectedsChanged: (val: NameID[]) => void;
};

export const SelectPresetAreaList = (props: Props) => {
  const { allArea, selecteds } = props;
  const [allChecked, setAllChecked] = useState(false);

  /**
   * 全体の変更をするチェックボックスのチェックが押された時の処理
   * 全ての行のチェックのオンオフを切り替える
   */
  const onAllChecked = (checked: boolean) => {
    if (checked) props.selectedsChanged(allArea.map((x) => x.area));
    else props.selectedsChanged([]);
  };

  const onCheckedChanged = (val: MapArea, checked: boolean) => {
    if (checked) props.selectedsChanged([...selecteds, val.area]);
    else props.selectedsChanged(selecteds.filter((x) => x.id !== val.area.id));
  };

  useEffect(() => {
    setAllChecked(allArea.length === selecteds.length);
  }, [allArea, selecteds]);
  return (
    <div style={{ display: "flex", flexDirection: "column", height: "100%", minHeight: 0 }}>
      <Form.Check
        checked={allChecked}
        onChange={(e) => onAllChecked(e.currentTarget.checked)}
        className="ms-2 mb-2"
        label={
          <span style={{ fontSize: "12px" }}>{`${
            allChecked ? "全てのチェックを外す" : "全てチェックする"
          }`}</span>
        }
      />
      <ListGroup as="ul" style={{ flex: 1, minHeight: 0, overflow: "auto" }}>
        {allArea.map((val) => (
          <ListGroup.Item key={`val_${val.area.id}`}>
            <Form.Check
              label={val.area.name}
              checked={selecteds.find((x) => x.id === val.area.id) !== undefined}
              onChange={(e) => onCheckedChanged(val, e.currentTarget.checked)}
            />
          </ListGroup.Item>
        ))}
      </ListGroup>
    </div>
  );
};
